module.exports = __webpack_public_path__ + "static/media/millie-bobby-brown-2000-10b978bacf3141eb83f0897a6939e580.fa18702f.jpg";